import React, { useCallback, useState } from "react";
import { useTranslation } from "components/translations/useTranslation";
import { Button, ButtonType } from "components/common/Button.component";
import OrganisationChartComponent from "components/organisationChart/OrganisationChart.component";
import { OrganisationChartNode, OrganisationChartProps } from "types/modals";

const OrganisationChart = OrganisationChartComponent as React.ComponentType<{
    isCompact?: boolean;
    onChangeSelectedNode: (node: OrganisationChartNode) => void;
}>;

const OrganisationChartModal = ({
    more,
    closeModal,
    loopFocus,
    initialFocusRef,
}: OrganisationChartProps): React.ReactElement => {
    const { translate } = useTranslation();
    const [selectedNode, setSelectedNode] = useState<OrganisationChartNode | null>(null);

    const handleChangeSelectedNode = useCallback((node: OrganisationChartNode) => {
        setSelectedNode(node);
    }, []);

    const handleOk = useCallback(() => {
        more.handleAction(selectedNode);
    }, [more, selectedNode]);

    const hideClose = !!more?.hideClose;

    return (
        <>
            <div className="ga-modal__content panel-body organisation-chart-dialog">
                <OrganisationChart
                    isCompact={true}
                    onChangeSelectedNode={handleChangeSelectedNode}
                />
            </div>
            <div className="ga-modal__actions">
                <Button
                    type={ButtonType.PRIMARY}
                    onClick={handleOk}
                    ref={initialFocusRef}
                    onBlur={hideClose ? loopFocus : undefined}
                    text={translate("popUp.ok")}
                />
                {!hideClose && (
                    <Button
                        type={ButtonType.SECONDARY}
                        onClick={closeModal}
                        onBlur={loopFocus}
                        text={translate("popUp.cancel")}
                    />
                )}
            </div>
        </>
    );
};

export default OrganisationChartModal;
